// libraries
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectedTab } from "../User";
// styles
import styles from "./tabbar.module.scss";

interface Props {
  handleSelection: (selected: SelectedTab) => void;
  selectedTab: SelectedTab;
}

const Tabbar = ({ handleSelection, selectedTab }: Props): JSX.Element => {
  const { t } = useTranslation();
  const ListData = [
    {
      tab: SelectedTab.CONTRACTS_TAB,
      text: t("lbl_home_active_transactions_title"),
    },
    {
      tab: SelectedTab.FEEDBACK_TAB,
      text: t("lbl_profile_list_reviews"),
    },
  ];

  const List = () => {
    return (
      <>
        {ListData?.map((item, index) => (
          <div
            key={`profile-item-${index}`}
            className={classNames(
              styles["list_item"],
              selectedTab === item?.tab && styles["list_item_active"]
            )}
            onClick={() => {
              handleSelection(item?.tab);
            }}>
            {selectedTab === item?.tab ? (
              <h4 className={styles.primary}>{item?.text}</h4>
            ) : (
              <p className={classNames(styles.p1, styles.g400)}>{item?.text}</p>
            )}
          </div>
        ))}
      </>
    );
  };

  return <div className={styles.tabbar_container}>{List()}</div>;
};

export default Tabbar;
